"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _AssetActivityDetailsComponent = _interopRequireDefault(require("./AssetActivityDetailsComponent"));
var _selectors = require("../../redux/margin/selectors");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  return {
    isMarginActive: (0, _selectors.isMarginActiveSelector)(state)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps)(_AssetActivityDetailsComponent["default"]);